/**
 * voice-v8 — Session-Wache (2026-06-27).
 *
 * Eine vom Server WIDERRUFENE Session (Konto aus der Allowlist entfernt /
 * login_allowed=0) liefert bei jedem /api-Aufruf 401 {"error":"auth-revoked"}.
 * Ohne Behandlung lief die App mit ALTEN, gecachten Daten des vorherigen
 * Nutzers weiter (Persona-Name, Belege, …) → Datenschutz-Leck + 401-Fehlerflut.
 *
 * Diese Wache fängt das GLOBAL ab: beim ersten `auth-revoked` werden ALLE
 * lokalen Daten (localStorage, sessionStorage, IndexedDB, Session-Cookie)
 * gelöscht und es wird sauber zur Anmeldung umgeleitet. So sieht eine fremde/
 * widerrufene Session NICHTS mehr vom vorherigen Nutzer.
 *
 * Wird als ERSTES in app.ts importiert, damit der fetch-Wrapper steht, bevor
 * die App ihre Datenabrufe startet.
 */
let handled = false;
const origFetch = window.fetch.bind(window);

window.fetch = async (
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> => {
  const res = await origFetch(input, init);
  if (res.status === 401 && !handled) {
    try {
      const body = await res.clone().text();
      if (body.includes("auth-revoked")) {
        handled = true;
        try {
          localStorage.clear();
        } catch {
          /* ignore */
        }
        try {
          sessionStorage.clear();
        } catch {
          /* ignore */
        }
        try {
          const dbs = (await indexedDB.databases?.()) ?? [];
          for (const d of dbs) if (d.name) indexedDB.deleteDatabase(d.name);
        } catch {
          /* ignore */
        }
        try {
          document.cookie = "voice-v8.session=; path=/; max-age=0";
        } catch {
          /* ignore */
        }
        if (!window.location.search.includes("session_revoked")) {
          window.location.replace("/?session_revoked=1");
        }
      }
    } catch {
      /* ignore — Wache darf den normalen Fluss nie stören */
    }
  }
  return res;
};

export {};
